import { Component } from 'react';

import ExpandableContent from '../ExpandableContent/ExpandableContent';

// Maybe we can use https://github.com/cookpete/react-player instead of FacebookPlayer
//import FacebookPlayer from 'react-facebook-player';
import ImageLoader from '@/components/features/posts/ImageLoader/ImageLoader';
import PostInfo from '@/components/features/posts/PostInfo/PostInfo';
import { LikeButton } from '@/components/features/posts/SocialBar/LikeButton/LikeButton';
import SocialBar from '@/components/features/posts/SocialBar/SocialBar';
import { withUser } from '@/components/shared/utilities/WithUser/WithUser';
import { getImageUrl, size } from '@/utils/attachment';
import { POST_ITEMS_TYPES, translatePostItemType } from '@/utils/constants';
import { getCollection } from '@/utils/social-media-share-links';
import styles from './FeedNews.module.scss';

interface IFeedNewsProps {
	data: any;
	user?: any;
}

class FeedNews extends Component<IFeedNewsProps> {
	constructor(props: IFeedNewsProps) {
		super(props);
	}

	render() {
		const { data, user } = this.props;
		const slug = data.slug || data.id;

		return (
			<div className={styles.newsFeed} key={data.id}>
				<ImageLoader
					src={getImageUrl(data.image, size.MEDIUM)}
					preloader={getImageUrl(data.image, size.PRELOADER)}
					className={styles.newsFeedImage}
				/>
				<div className={styles.newsFeedContent}>
					<div className={styles.newsFeedBox}>
						<div className={styles.newsFeedBoxContent}>
							<div className={styles.collectionFeedType}>{translatePostItemType(POST_ITEMS_TYPES[data.type])}</div>
							<div className={styles.newsFeedTitle}>{data.title}</div>
							<PostInfo className={styles.newsFeedInfo} data={data} />
							<ExpandableContent className={styles.newsFeedDescription} content={data.content} />
						</div>
						<div className={styles.newsFeedBoxFooter}>
							{user ? <LikeButton faveable={data} /> : null}

							<SocialBar
								shareLinksCollection={getCollection('/feed/' + slug, data)}
								menuContainerClassName={styles.newsFeedSocialMenuContainer}
								menuCloseClassName={styles.newsFeedSocialMenuClose}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withUser(FeedNews);
